import React from "react";
import { HamburgerMenu } from "../../components/HamburgerMenu";
import { NavComparison } from "../../components/NavComparison";
import { NavLogin } from "../../components/NavLogin";
import { NavPricing } from "../../components/NavPricing";
import { NavSolutions } from "../../components/NavSolutions";
import { NavWhyIntelead } from "../../components/NavWhyIntelead";
import "./style.css";

export const Menu = () => {
  return (
    <div className="menu">
      <div className="div-9">
        <NavSolutions className="design-component-instance-node" />
        <NavWhyIntelead className="nav-why-intelead-2" />
        <NavPricing className="nav-pricing-2" />
        <NavComparison className="nav-comparison-2" />
        <NavLogin className="nav-login-instance" />
        <HamburgerMenu
          className="hamburger-menu-instance"
          property="/img/hamburger-menu-2x.png"
          property1="variant-2"
        />
      </div>
    </div>
  );
};
